import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// Import Routes
import { authProtectedRoutes, publicRoutes, authProtectedUserRoutes } from "./routes/";

// Import VerticalLayout
import VerticalLayout from "./components/VerticalLayout/";

// Import scss
import "./assets/scss/theme.scss";

import { useSelector } from 'react-redux';
function App() {
  const Layout = VerticalLayout;

  const PrivateRoute = ({ component: Component, ...rest }) => {
    const sessionToken = sessionStorage.getItem('sessionToken');
    const sessionExpiration = sessionStorage.getItem('sessionExpiration');
    const currentTime = new Date().getTime();
    const userRole = useSelector((state) => state.roleReducer.userRole);

    if (sessionToken && sessionExpiration && currentTime < sessionExpiration) {
      const allowedRoutes = userRole === 'admin' ? authProtectedRoutes : authProtectedUserRoutes;
      const isRouteAllowed = allowedRoutes.some((route) => route.path === rest.path);

      return isRouteAllowed ? (
        <Route {...rest} render={(props) => <Layout><Component {...props} /></Layout>} />
      ) : (
        <Redirect to="/dashboard" />
      );
    } else {
      // Session is not active, redirect to the login page
      return <Redirect to="/" replace />;
    }
  };

  return (
    <React.Fragment>
      <Switch>
        {/* Public routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            exact
            component={route.component}
          />
        ))}

        {/* Protected routes */}
        {authProtectedRoutes.map((route, idx) => (
          <PrivateRoute key={idx} path={route.path} exact component={route.component} />
        ))}
      </Switch>
    </React.Fragment>
  );
}

export default App;
